import { BookingService } from "./BookingService";
import { PromoCodeService } from "./CampainService";
import { EmailList } from "./EmailList";
import { GroupService } from "./GroupService";
import { PaymentService } from "./PaymentService";
import { SeminarService } from "./SeminarService";
import { VideoService } from "./VideoService";

export const DataService = {
    EmailList,
    PaymentService,
    BookingService,
    PromoCodeService,
    VideoService,
    GroupService,
    SeminarService
}